import React from 'react'
import { useTranslation } from "react-i18next";
import { Dialog, DialogType, DialogFooter } from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Col, Row } from 'react-bootstrap';


function FinalizePartieAdvaiceDialog(props) {
    const { t } = useTranslation();
    
    const inputParam_IsModalOpen = props.isModalOpen !== null && props.isModalOpen !== undefined ? props.isModalOpen : null;
    const inputParam_SetterIsModalOpen = props.setIsModalOpen !== null && props.setIsModalOpen !== undefined ? props.setIsModalOpen : null;
    const inputParam_SetterActionResult = props.setterAction !== null && props.setterAction !== undefined ? props.setterAction : null;
    const inputParam_ContractCode = props.contractCode !== null && props.contractCode !== undefined ? props.contractCode : null;
    
    const onAccepModal = () => {
        inputParam_SetterActionResult && inputParam_SetterActionResult(true);
        inputParam_SetterIsModalOpen(false);
    }

    const onCancelModal = () => {
        inputParam_SetterActionResult && inputParam_SetterActionResult(false);
        inputParam_SetterIsModalOpen(false);
    }

    //Render de componente.
    return (
        <Dialog
            hidden={!inputParam_IsModalOpen}
            onDismiss={onCancelModal}
            minWidth={850}
            maxWidth={1300}
            dialogContentProps={{
                type: DialogType.normal,
                styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                title: t('data-lang-boxname-warning'),
            }}
            modalProps={{ isBlocking: true, }}
        >
            <div>
                { t('data-lang-msg-finalizepartiesadvice').replace("{0}", inputParam_ContractCode) }
            </div>
            <DialogFooter>
                <Row>
                    <Col></Col>
                    <Col className='col-auto me-auto'>
                        <PrimaryButton onClick={ onAccepModal }>{ t('data-lang-btn-accept') }</PrimaryButton>
                    </Col>
                    <Col className='col-auto me-auto'>
                        <DefaultButton onClick={ onCancelModal }>{ t('data-lang-btn-cancel') }</DefaultButton>
                    </Col>
                </Row>
            </DialogFooter>
        </Dialog>
        );
}
        
export default FinalizePartieAdvaiceDialog;